import React from "react";
import {PageHero} from "../common/PageHero";

export const Calender = () => {
    return (
        <>
            <PageHero title={'Kalender'}
                      badge={'Agenda'}
                      lead={'Alle wedstrijden, trainingen en clubmomenten op een rij.'}/>
            <div className={'ttc-section'}>
                <div className={'ttc-embed'} style={{height: 640}}>
                    <iframe title={'google calendar'}
                            src="https://calendar.google.com/calendar/embed?src=ttcbartmerksembestuur%40gmail.com&ctz=Europe%2FBrussels"
                            style={{border: 0}}/>
                </div>
            </div>
        </>
    )
}
